export default "__VITE_ASSET__DSVl_9NV__"